module.exports = __webpack_public_path__ + "static/files/user_import_sample.csv";